const formatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
});

export const formatCurrency = amount => formatter.format(amount);

export default { formatCurrency };
